import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseItemComponent } from '../base-item/base-item.component';
import { CartItem } from '../../../models/cart-item.model';

@Component({
  selector: 'usb-rent-a-car-item',
  templateUrl: './rent-a-car-item.component.html',
  styleUrls: ['./rent-a-car-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RentACarItemComponent extends BaseItemComponent {
  @Input() item: any;
  @Input() clientsSettingAppBooking: any;

  /**
   * Parsea un string de fecha en formato dd-MM-yyyy a Date.
   * Angular DatePipe solo entiende formato ISO (yyyy-MM-dd), no dd-MM-yyyy.
   */
  parseDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    const parts = dateStr.split('-');
    if (parts.length !== 3) return null;
    const [day, month, year] = parts;
    return new Date(`${year}-${month}-${day}`);
  }

  getPickupLocation(): string {
    if (this.item?.pickupLocation?.type === 'airport') {
      return this.item.pickupLocation.name || '';
    }
    return this.item?.pickupLocation?.city_name || '';
  }

  getReturnLocation(): string {
    if (this.item?.returnLocation?.type === 'airport') {
      return this.item.returnLocation.name || '';
    }
    return this.item?.returnLocation?.city_name || '';
  }
}
